'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var mapStateToProps = function mapStateToProps(state) {
    return {
        displayName: state.getIn(['app', 'currentUser', 'name', 'displayName'])
    };
};

// Components


var UserNameReadOnly = function UserNameReadOnly(_ref) {
    var displayName = _ref.displayName,
        toggleEditable = _ref.toggleEditable;
    return _react2.default.createElement(
        'div',
        { className: 'UserNameReadOnly' },
        _react2.default.createElement(
            'span',
            null,
            displayName
        ),
        _react2.default.createElement(
            _LinkButton2.default,
            { onClickFn: toggleEditable },
            'Change'
        )
    );
};

UserNameReadOnly.propTypes = {
    displayName: _propTypes2.default.string,
    toggleEditable: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserNameReadOnly);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/editableUserName/UserNameReadOnly.js
// module id = 2091
// module chunks = 0